module.exports = __webpack_public_path__ + "img/banner-12-1@2x.7d967372.jpg";